module.exports = __webpack_public_path__ + "static/img/logo8.28e7b86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo8.png
// module id = Q8hk
// module chunks = 0